import React, { useCallback } from "react";
import localstory from "localstory";
import { Text, Banner, Button, Icon } from "@bookingcom/bui-react";
import { InfoSignIcon } from "@bookingcom/bui-assets-react/streamline";
import { useI18n, t } from "@bookingcom/lingojs-react";
import useUserAgent from "../../../hooks/useUserAgent.js";
import useModalDialog from "../../../hooks/useModalDialog.js";
import useToggle from "../../../hooks/useToggle.js";
import styles from "./SirfInfoBanner.module.css";
import { mcn } from "../../../utils/mergeClassnames.js";
const getSessionStorageKeyName = (bannerName) => `spanish_islands_info_banner_is_closed_by_user__${bannerName}`;
const SirfInfoBanner = ({ bannerName, bannerContent, className }) => {
    const localStore = localstory(window.sessionStorage, "flights");
    const { isMobile } = useUserAgent();
    const i18n = useI18n();
    const Modal = useModalDialog();
    const { visible: modalActive, show: showModal, hide: hideModal } = useToggle();
    const isBannerClosed = Boolean(localStore.get(getSessionStorageKeyName(bannerName)));
    const onBannerClose = useCallback(() => {
        localStore.set(getSessionStorageKeyName(bannerName), true);
    }, [localStore, bannerName]);
    return (React.createElement(React.Fragment, null,
        !isBannerClosed && (React.createElement(Banner, { className: mcn(styles.bannerRoot, className), startIcon: React.createElement(Icon, { svg: InfoSignIcon, size: "large" }), actions: [
                {
                    text: i18n.trans(t("flights_action_learn_more")),
                    onClick: showModal
                }
            ], closeAriaLabel: "Close banner", onClose: onBannerClose, attributes: { "data-testid": "sirf_info_banner" } }, bannerContent)),
        React.createElement(Modal, { active: modalActive, onCloseTrigger: hideModal, fill: isMobile, attributes: { "data-testid": "sirf_info_banner_modal" } },
            React.createElement(ModalContent, { onCtaButtonClick: hideModal }))));
};
const ModalContent = ({ onCtaButtonClick }) => {
    const { isMobile } = useUserAgent();
    const i18n = useI18n();
    return (React.createElement("div", { className: styles.modalContent },
        React.createElement(Text, { variant: "headline_3", className: styles.modalTitle }, i18n.trans(t("flights_modal_spanish_discount_header"))),
        React.createElement(Text, { className: styles.modalParagraph, variant: "body_2" }, i18n.trans(t("flights_modal_spanish_discount_1"))),
        React.createElement(Text, { variant: "strong_2" }, i18n.trans(t("flights_modal_spanish_discount_subheader"))),
        React.createElement(Text, { className: styles.modalParagraph, variant: "body_2" }, i18n.trans(t("flights_modal_spanish_discount_2"))),
        React.createElement(Text, { className: styles.modalParagraph, variant: "body_2" }, i18n.trans(t("flights_modal_spanish_discount_3"))),
        React.createElement(Button, { text: i18n.trans(t("flights_ok_got_action")), onClick: onCtaButtonClick, className: styles.modalCtaButton, size: isMobile ? "large" : "medium", attributes: { "data-testid": "ok" } })));
};
export default SirfInfoBanner;
